import { Button } from '@breetometer/components';
import { MoneyBagIcon } from 'BreetAssets';
import { memo } from 'react';

export const FiatInputMaxComponent = memo(
	({ isMaxFeat, handleMaxClick }: { isMaxFeat: boolean; handleMaxClick?: () => void }) => (
		<>
			{isMaxFeat && (
				<div className='fiat_input_max'>
					<Button
						variant='native'
						type='button'
						onClick={handleMaxClick}
						className='border-dark-navy bg-primary-400 color-neutral-50'
					>
						<MoneyBagIcon className='svg-dark svg-dark-outline svg-dark-fill' />
						Max
					</Button>
				</div>
			)}
		</>
	)
);

FiatInputMaxComponent.displayName = 'FiatInputMaxComponent';
